import { Box, Button, CircularProgress, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { FC, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { downloadInvoiceArchiveRequest } from 'redux/reducers/invoiceManagement/reducer';
import { selectDownloadInvoiceArchiveLoader } from 'redux/reducers/invoiceManagement/selectors';
import { COLORS } from 'services/constants/colors';

export const InvoiceArchiveDownload: FC = () => {
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();
	const filename = searchParams.get('filename');
	const isLoading = useSelector(selectDownloadInvoiceArchiveLoader);
	const [downloaded, setDownloaded] = useState(false);

	const handleDownload = useCallback(() => {
		if (filename) {
			setDownloaded(true);
			dispatch(downloadInvoiceArchiveRequest({ filename }));
		}
	}, [dispatch, filename]);

	if (!filename) {
		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '60vh',
				}}
			>
				<Typography sx={{ color: 'error.main', fontWeight: 600, fontSize: '1.2rem' }}>
					Missing &quot;filename&quot; parameter in URL
				</Typography>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '60vh',
				gap: 2,
			}}
		>
			{isLoading ? (
				<>
					<CircularProgress sx={{ color: COLORS.PRIMARY }} />
					<Typography sx={{ color: COLORS.PRIMARY, fontWeight: 600, fontSize: '1.2rem' }}>
						Downloading archive...
					</Typography>
				</>
			) : downloaded ? (
				<Typography sx={{ color: COLORS.PRIMARY, fontWeight: 600, fontSize: '1.2rem' }}>
					Download complete. You can close this page.
				</Typography>
			) : (
				<Button
					variant="contained"
					startIcon={<DownloadIcon />}
					onClick={handleDownload}
					sx={{ textTransform: 'none', fontSize: '1rem', px: 4, py: 1.5 }}
				>
					Download Invoices
				</Button>
			)}
		</Box>
	);
};
